var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTransport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.9375 6.75H20.0625",
    stroke: "#2C3B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.9375 11.25H20.0625",
    stroke: "#2C3B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0625 18H3.93752V6.00002C3.93628 5.7042 3.99363 5.41106 4.10626 5.13752C4.2189 4.86397 4.38458 4.61544 4.59376 4.40626C4.80294 4.19708 5.05147 4.0314 5.32502 3.91876C5.59856 3.80613 5.8917 3.74878 6.18752 3.75002H17.8125C18.1083 3.74878 18.4015 3.80613 18.675 3.91876C18.9486 4.0314 19.1971 4.19708 19.4063 4.40626C19.6155 4.61544 19.7811 4.86397 19.8938 5.13752C20.0064 5.41106 20.0638 5.7042 20.0625 6.00002V18Z",
    stroke: "#2C3B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0625 18V20.25C20.0625 20.4489 19.9835 20.6397 19.8428 20.7803C19.7022 20.921 19.5114 21 19.3125 21H17.0625C16.8636 21 16.6728 20.921 16.5322 20.7803C16.3915 20.6397 16.3125 20.4489 16.3125 20.25V18",
    stroke: "#2C3B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.6875 18V20.25C7.6875 20.4489 7.60848 20.6397 7.46783 20.7803C7.32718 20.921 7.13641 21 6.9375 21H4.6875C4.48859 21 4.29782 20.921 4.15717 20.7803C4.01652 20.6397 3.9375 20.4489 3.9375 20.25V18",
    stroke: "#2C3B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.875 15.375C8.28921 15.375 8.625 15.0392 8.625 14.625C8.625 14.2108 8.28921 13.875 7.875 13.875C7.46079 13.875 7.125 14.2108 7.125 14.625C7.125 15.0392 7.46079 15.375 7.875 15.375Z",
    fill: "#2C3B60"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.125 15.375C16.5392 15.375 16.875 15.0392 16.875 14.625C16.875 14.2108 16.5392 13.875 16.125 13.875C15.7108 13.875 15.375 14.2108 15.375 14.625C15.375 15.0392 15.7108 15.375 16.125 15.375Z",
    fill: "#2C3B60"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransport);
export default __webpack_public_path__ + "static/media/Transport.406420079ea4f84b56614055d190dd82.svg";
export { ForwardRef as ReactComponent };